import { createAsyncThunk } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

import { selectCurrentThread, setExternalActionsErrors, updateThread } from './threadsUiSlice';
import { toastError } from 'src/actions/toast';
import { UpdateModuleCallbackParams, externalActionsDiff } from './externalActionHelper';

export const updateExternalActionsIfNeeded = createAsyncThunk(
  'threadUi/updateExternalActionsIfNeeded',
  async ({ forceUpdate }: { forceUpdate: boolean }, { dispatch, getState }: any) => {
    const currentThread = cloneDeep(selectCurrentThread(getState()));
    const { values: externalActions } = (getState() as { sidekickExternalActions }).sidekickExternalActions;
    let threadHasChanged = false;

    const updateModule = ({ attr, moduleData }: UpdateModuleCallbackParams) => {
      set(currentThread.nextData, attr, moduleData);
      threadHasChanged = true;
    };

    try {
      const errors = await externalActionsDiff(currentThread, externalActions, updateModule);
      if (threadHasChanged && forceUpdate) {
        dispatch(updateThread({ thread: currentThread }));
      }
      dispatch(setExternalActionsErrors(errors));
    } catch (e) {
      dispatch(toastError('There was an error while validating external actions.'));
      return;
    }
  }
);
